import {
  LIST_COUNTRY_REQUEST,
  LIST_COUNTRY_SUCCESS,
  LIST_COUNTRY_FAIL,
  LIST_PROVINCE_REQUEST,
  LIST_PROVINCE_SUCCESS,
  LIST_PROVINCE_FAIL,
  LIST_CITY_REQUEST,
  LIST_CITY_SUCCESS,
  LIST_CITY_FAIL,
  LIST_SUBDISTRICT_REQUEST,
  LIST_SUBDISTRICT_SUCCESS,
  LIST_SUBDISTRICT_FAIL,
  LIST_VILLAGE_REQUEST,
  LIST_VILLAGE_SUCCESS,
  LIST_VILLAGE_FAIL
} from '../../constants/regions'

const initialState = {
  countries: [],
  provinces: [],
  cities: [],
  subdistricts: [],
  villages: [],
  loading: false,
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

export const regionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_COUNTRY_REQUEST:
      return { ...state, loading: true }
    case LIST_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.payload,
        ...(action.pageable && { pageable: action.pageable })
      }
    case LIST_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        countries: action?.dummy
      }
    case LIST_PROVINCE_REQUEST:
      return { ...state, loading: true }
    case LIST_PROVINCE_SUCCESS:
      return {
        ...state,
        loading: false,
        provinces: action.payload,
        ...(action.pageable && { pageable: action.pageable })
      }
    case LIST_PROVINCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        provinces: action?.dummy
      }
    case LIST_CITY_REQUEST:
      return { ...state, loading: true }
    case LIST_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        cities: action.payload,
        ...(action.pageable && { pageable: action.pageable })
      }
    case LIST_CITY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        cities: action?.dummy
      }
    case LIST_SUBDISTRICT_REQUEST:
      return { ...state, loading: true }
    case LIST_SUBDISTRICT_SUCCESS:
      return {
        ...state,
        loading: false,
        subdistricts: action.payload,
        ...(action.pageable && { pageable: action.pageable })
      }
    case LIST_SUBDISTRICT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        subdistricts: action?.dummy
      }
    case LIST_VILLAGE_REQUEST:
      return { ...state, loading: true }
    case LIST_VILLAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        villages: action.payload,
        ...(action.pageable && { pageable: action.pageable })
      }
    case LIST_VILLAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        villages: action?.dummy
      }
    default:
      return state
  }
}

export default regionsReducer
